module.exports = __webpack_public_path__ + "static/media/amruni_mehta.5008610b.png";